import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ImprimeTicketComponent } from '../../imprime-ticket/imprime-ticket.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as moment from 'moment';
import {ExcelService} from '../../excel.service';

export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-nota-venta',
  templateUrl: './nota-venta.component.html',
  styleUrls: ['./nota-venta.component.css'],
    providers: [
      { provide: MatDialogRef,useValue: {} },
      {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
      {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
      {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
    ] 
})
export class NotaVentaComponent implements OnInit {
  errMsg:any;
  tickets:any=[];
  roles:any=[];
  prods:any=[];
  descs:any=[];
  users:any=[];
  loading:boolean=false;
  fecIni:any = moment();
  fecFin:any = moment();
  usr:string="0";
  gpo:any=[];
  origenes:any=[];
  idGpo:number=1;  
  forma:any=[];
  arrForma:any=[];
  idForma:number=0;
  agruparTickets:boolean = true;
  separaFolio:boolean=false;
  totMonto:number = 0;
  totOperaciones:number = 0;
  totFolios:number = 0;
  selMonto:number = 0;
  selOperaciones:number = 0;
  selFolios:number = 0;
  info:any=[];
  cteSAE:number=-1;
  folioSAE:number=-1;
  auxPreSAE:any;
  lonFolioSAE:number=-1;
  auxSerSAE:any;
  serSAE:string="";
  strPrefijoSAE: string = '';
  existeArchivo:any;
  notaVenta:any;
  maxFolioSAE:any;
  
  thisForm = new FormGroup({
    gpo: new FormControl(this.idGpo, []),
    forma: new FormControl([]),    
    cveSAE: new FormControl([]),    
    separaFolio: new FormControl(this.separaFolio, []),
  });



  constructor(private dataService: DataService, private excelService: ExcelService) { }

  ngOnInit() {
    this.loading = true;
    this.dataService.getFormAct().subscribe(
                    rows => {   
                            this.forma = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnFormasCargados());

    this.dataService.getGrupos().subscribe(
                    rows => {   
                            this.gpo = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnGruposCargados());

    this.dataService.getUsuarios('%').subscribe(
                    rows => {   
                            this.users = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnUsuariosCargados());
  this.dataService.getVars("SAE-CTE").subscribe(
                    rows => {   
                            this.cteSAE = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnCteSAEObtenido());     
    this.dataService.getVarsUnidad("SAE-SER").subscribe(
                    rows => {   
                            this.auxSerSAE = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnSerSAEObtenido());      
      this.dataService.getVars("SAE-FOL").subscribe(
                      rows => {   
                              this.folioSAE = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFolioSAEObtenido());                                         
  }

  fnFormasCargados(){
    for(var f = 0; f < this.forma.length; f++){
      //this.forma[f].checked = false;
      this.forma[f].checked = true;
    }
    //console.log(this.forma)
  }

  fnGruposCargados(){
    //console.log(this.gpo);
  }

  fnOrigenesCargados(){
    //console.log(this.origenes);
  }

  fnUsuariosCargados(){
    //console.log(this.users);
    this.dataService.getRoles().subscribe(
                      rows => {   
                              this.roles = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnRolesCargados());
}

  fnRolesCargados(){
    //console.log(this.roles);
    this.dataService.getDescuentos(-1).subscribe(
                      rows => {   
                              this.descs = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnDescuentosCargados());
  }

  fnDescuentosCargados(){
    //console.log(this.descs);
    this.dataService.getProductos().subscribe(
                      rows => {   
                              this.prods = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnProductosCargados());
  }

  fnProductosCargados(){
    //console.log(this.prods);
    this.fnCargaReporte();
  }
  
  fnCteSAEObtenido(){
    //console.log(this.cteSAE);
  }

  fnSerSAEObtenido(){
    //console.log(this.auxSerSAE);
    if(this.auxSerSAE)
      this.serSAE = this.auxSerSAE[0].valor;
  }

  fnFolioSAEObtenido(){
    //console.log("FOLIO: " + this.folioSAE);    
    if(this.folioSAE >= 0){
      this.dataService.getVars("SAE-LON").subscribe(
                            rows => {   
                                    this.lonFolioSAE = <any>rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnLongFolioSAEObtenido());     
      this.dataService.getVarsUnidad("SAE-PRE").subscribe(
                            rows => {   
                                    this.auxPreSAE = <any>rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnPreFolioSAEObtenido());   
    }
  }

  fnLongFolioSAEObtenido(){
    //console.log("LONGITUD: " + this.lonFolioSAE);
    if(this.lonFolioSAE>0){
    }
  }

  fnPreFolioSAEObtenido(){
    if(this.auxPreSAE){
      this.strPrefijoSAE = this.auxPreSAE[0].valor;
    }
    //console.log("PREFIJO: " + this.prefijoSAE)
    setTimeout(() => {
      this.dataService.maxFolioSAE(this.strPrefijoSAE).subscribe(
                                rows => {   
                                        this.maxFolioSAE = <any>rows
                                        },          
                                error => this.errMsg = <any>error,
                                () => this.fnMaxFolioSAEObtenido());  
    }, 50);
  }

  fnMaxFolioSAEObtenido(){
    console.log(this.maxFolioSAE)
    if(this.maxFolioSAE){
      var maxFolio = this.maxFolioSAE[0].maxFolio * 1;
      if(this.folioSAE > maxFolio){
        console.log("SI el folio de sistema (" + this.folioSAE + ") es mayor que el folio maximo (" + maxFolio + "); usar folio sistema: " + this.folioSAE)
        this.maxFolioSAE = this.folioSAE;
      }
      else{
        console.log("SI el folio de sistema (" + this.folioSAE + ") es menor que el folio maximo (" + maxFolio + "); usar folio maximo + 1: " + (maxFolio + 1))
        this.maxFolioSAE = maxFolio + 1;
      }
    }
  }

  fnCargaReporte(){
    this.info = null;
    var auxForma = [];
    for(var f = 0; f < this.forma.length; f++){
      if(this.forma[f].checked ){
        auxForma.push(this.forma[f].id);
      }
    }

    if(this.separaFolio){
      this.dataService.notaVenta('%', this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"), this.idGpo, auxForma.join(), '0,1').subscribe(
                                  rows => {   
                                          this.tickets = <any>rows
                                          },          
                                  error => this.errMsg = <any>error,
                                  () => this.fnTicketsCargados());
    }
    else{
      this.dataService.notaVentaGpo('%', this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"), this.idGpo, auxForma.join(), '0,1').subscribe(
                                  rows => {   
                                          this.tickets = <any>rows
                                          },          
                                  error => this.errMsg = <any>error,
                                  () => this.fnTicketsCargados());
    }
  }

  fnTicketsCargados(){
    console.log(this.tickets);
    var gpo1NumFolios = 0;
    var gpo1Total = 0;
    var gpo1Cancelados = 0;
    var gpo1FolioIni = -1;
    var gpo1FolioFin = -1;
    var gpo1ReciboIni = -1;
    var gpo1ReciboFin = -1;

    var gpo2NumFolios = 0;
    var gpo2Total = 0;
    var gpo2Cancelados = 0;
    var gpo2FolioIni = -1;
    var gpo2FolioFin = -1;
    var gpo2ReciboIni = -1;
    var gpo2ReciboFin = -1;

    var gpo3NumFolios = 0;
    var gpo3Total = 0;
    var gpo3Cancelados = 0;
    var gpo3FolioIni = -1;
    var gpo3FolioFin = -1;
    var gpo3ReciboIni = -1;
    var gpo3ReciboFin = -1;

    var gpo4NumFolios = 0;
    var gpo4Total = 0;
    var gpo4Cancelados = 0;
    var gpo4FolioIni = -1;
    var gpo4FolioFin = -1;
    var gpo4ReciboIni = -1;
    var gpo4ReciboFin = -1;

    var gpo991NumFolios = 0;
    var gpo991Total = 0;
    var gpo991Cancelados = 0;
    var gpo991FolioIni = -1;
    var gpo991FolioFin = -1;
    var gpo991ReciboIni = -1;
    var gpo991ReciboFin = -1;

    var gpo999NumFolios = 0;
    var gpo999Total = 0;
    var gpo999Cancelados = 0;
    var gpo999FolioIni = -1;
    var gpo999FolioFin = -1;
    var gpo999ReciboIni = -1;
    var gpo999ReciboFin = -1;

    var auxTotFolios = 0;
    var auxTotOp = 0;
    var auxTot = 0;
    var selTotFolios = 0;
    var selTotOp = 0;
    var selTot = 0;

    this.info = [];
    var auxLen = 0;
    if(this.tickets)
      auxLen = this.tickets.length;
    for(var i = 0; i < auxLen; i++){
      if(this.agruparTickets){
        auxTot += this.tickets[i].tot;
        auxTotFolios += this.tickets[i].n;
        auxTotOp++;
        if(this.tickets[i].sel = true && this.tickets[i].stat == 0){
          selTot += this.tickets[i].tot;
          selTotFolios += this.tickets[i].n;
          selTotOp++;  
        }
      }
      else{
        auxTot += this.tickets[i].tot;
        auxTotFolios++;
        if(this.tickets[i].i == 1)
          auxTotOp++;
        if(this.tickets[i].sel = true && this.tickets[i].stat == 0){
          selTot += this.tickets[i].tot;
          selTotFolios += this.tickets[i].n;
          if(this.tickets[i].i == 1)
            selTotOp++;  
        }
      }

      if(this.tickets[i].idGpo == 1 && this.tickets[i].idProd < 99990){
        if(this.agruparTickets){
          gpo1NumFolios += this.tickets[i].n;
          if(this.tickets[i].stat < 0)
            gpo1Cancelados += this.tickets[i].n;
          else
            gpo1Total += this.tickets[i].tot
        }
        else{
          gpo1NumFolios++;
          if(this.tickets[i].stat < 0)
            gpo1Cancelados++;
          else
            gpo1Total += this.tickets[i].tot;        
        }
        if(gpo1FolioIni < 0 || gpo1FolioIni > this.tickets[i].folio)
          gpo1FolioIni = this.tickets[i].folio
        if(gpo1FolioFin < this.tickets[i].folio)
          gpo1FolioFin = this.tickets[i].folio
        if(gpo1ReciboIni < 0 || (this.tickets[i].folioGpo > 0 && gpo1ReciboIni > this.tickets[i].folioGpo))
          gpo1ReciboIni = this.tickets[i].folioGpo
        if(gpo1ReciboFin < this.tickets[i].folioGpo)
          gpo1ReciboFin = this.tickets[i].folioGpo
      }
      if(this.tickets[i].idGpo == 2 && this.tickets[i].idProd < 99990){
        if(this.agruparTickets){
          gpo2NumFolios += this.tickets[i].n;
          if(this.tickets[i].stat < 0)
            gpo2Cancelados += this.tickets[i].n;
          else
            gpo2Total += this.tickets[i].tot
        }
        else{
          gpo2NumFolios++;
          if(this.tickets[i].stat < 0)
            gpo2Cancelados++;
          else
            gpo2Total += this.tickets[i].tot;        
        }
        if(gpo2FolioIni < 0 || gpo2FolioIni > this.tickets[i].folio)
          gpo2FolioIni = this.tickets[i].folio
        if(gpo2FolioFin < this.tickets[i].folio)
          gpo2FolioFin = this.tickets[i].folio
        if(gpo2ReciboIni < 0 || (this.tickets[i].folioGpo > 0 && gpo2ReciboIni > this.tickets[i].folioGpo))
          gpo2ReciboIni = this.tickets[i].folioGpo
        if(gpo2ReciboFin < this.tickets[i].folioGpo)
          gpo2ReciboFin = this.tickets[i].folioGpo
      }
      if(this.tickets[i].idGpo == 3 && this.tickets[i].idProd < 99990){
        if(this.agruparTickets){
          gpo3NumFolios += this.tickets[i].n;
          if(this.tickets[i].stat < 0)
            gpo3Cancelados += this.tickets[i].n;
          else
            gpo3Total += this.tickets[i].tot
        }
        else{
          gpo3NumFolios++;
          if(this.tickets[i].stat < 0)
            gpo3Cancelados++;
          else
            gpo3Total += this.tickets[i].tot;        
        }
        if(gpo3FolioIni < 0 || gpo3FolioIni > this.tickets[i].folio)
          gpo3FolioIni = this.tickets[i].folio
        if(gpo3FolioFin < this.tickets[i].folio)
          gpo3FolioFin = this.tickets[i].folio
        if(gpo3ReciboIni < 0 || (this.tickets[i].folioGpo > 0 && gpo3ReciboIni > this.tickets[i].folioGpo))
          gpo3ReciboIni = this.tickets[i].folioGpo
        if(gpo3ReciboFin < this.tickets[i].folioGpo)
          gpo3ReciboFin = this.tickets[i].folioGpo
      }
      if(this.tickets[i].idGpo == 4 && this.tickets[i].idProd < 99990){
        if(this.agruparTickets){
          gpo4NumFolios += this.tickets[i].n;
          if(this.tickets[i].stat < 0)
            gpo4Cancelados += this.tickets[i].n;
          else
            gpo4Total += this.tickets[i].tot
        }
        else{
          gpo4NumFolios++;
          if(this.tickets[i].stat < 0)
            gpo4Cancelados++;
          else
            gpo4Total += this.tickets[i].tot;        
        }
        if(gpo4FolioIni < 0 || gpo4FolioIni > this.tickets[i].folio)
          gpo4FolioIni = this.tickets[i].folio
        if(gpo4FolioFin < this.tickets[i].folio)
          gpo4FolioFin = this.tickets[i].folio
        if(gpo4ReciboIni < 0 || (this.tickets[i].folioGpo > 0 && gpo4ReciboIni > this.tickets[i].folioGpo))
          gpo4ReciboIni = this.tickets[i].folioGpo
        if(gpo4ReciboFin < this.tickets[i].folioGpo)
          gpo4ReciboFin = this.tickets[i].folioGpo

      }
      if(this.tickets[i].idProd == 99991){
        if(this.agruparTickets){
          gpo991NumFolios += this.tickets[i].n;
          if(this.tickets[i].stat < 0)
            gpo991Cancelados += this.tickets[i].n;
          else
            gpo991Total += this.tickets[i].tot
        }
        else{
          gpo991NumFolios++;
          if(this.tickets[i].stat < 0)
            gpo991Cancelados++;
          else
            gpo991Total += this.tickets[i].tot;        
        }
        if(gpo991FolioIni < 0 || gpo991FolioIni > this.tickets[i].folio)
          gpo991FolioIni = this.tickets[i].folio
        if(gpo991FolioFin < this.tickets[i].folio)
          gpo991FolioFin = this.tickets[i].folio
        if(gpo991ReciboIni < 0 || (this.tickets[i].folioGpo > 0 && gpo991ReciboIni > this.tickets[i].folioGpo))
          gpo991ReciboIni = this.tickets[i].folioGpo
        if(gpo991ReciboFin < this.tickets[i].folioGpo)
          gpo991ReciboFin = this.tickets[i].folioGpo
      }
      if(this.tickets[i].idProd > 99991){   //--> TODOS LOS INGRESOS (EXCEPTO TIENDA)
        if(this.agruparTickets){
          gpo999NumFolios += this.tickets[i].n;
          if(this.tickets[i].stat < 0)
            gpo999Cancelados += this.tickets[i].n;
          else
            gpo999Total += this.tickets[i].tot
        }
        else{
          gpo999NumFolios++;
          if(this.tickets[i].stat < 0)
            gpo999Cancelados++;
          else
            gpo999Total += this.tickets[i].tot;        
        }
        if(gpo999FolioIni < 0 || gpo999FolioIni > this.tickets[i].folio)
          gpo999FolioIni = this.tickets[i].folio
        if(gpo999FolioFin < this.tickets[i].folio)
          gpo999FolioFin = this.tickets[i].folio
        if(gpo999ReciboIni < 0 || (this.tickets[i].folioGpo > 0 && gpo999ReciboIni > this.tickets[i].folioGpo))
          gpo999ReciboIni = this.tickets[i].folioGpo
        if(gpo999ReciboFin < this.tickets[i].folioGpo)
          gpo999ReciboFin = this.tickets[i].folioGpo
      }
    
      if(this.tickets[i].idDesc >= 0 && this.tickets[i].idDesc < 99){
        var auxDesc = this.dataService.findItemInObject(this.descs, this.tickets[i].idDesc, "id");
        var auxAux = "";
        try{
          auxAux = auxDesc.descuento;
        }
        catch{

        }
        this.tickets[i].aplicaDescuento = " (" + auxAux + ")";
      }
      this.tickets[i].usuario = this.dataService.findItemInObject(this.users, this.tickets[i].idUsuario, "idUsuario").nombre;
    }
    this.info.push({ 'totOperaciones':auxTotOp,
                     'totFolios': auxTotFolios,  
                     'Taquilla': {'numFolios':gpo1NumFolios, 'folioIni':gpo1FolioIni, 'folioFin':gpo1FolioFin, 'reciboIni':gpo1ReciboIni, 'reciboFin':gpo1ReciboFin, 'cancelados':gpo1Cancelados, 'total':gpo1Total },
                     'DesInst': {'numFolios':gpo2NumFolios, 'folioIni':gpo2FolioIni, 'folioFin':gpo2FolioFin, 'reciboIni':gpo2ReciboIni, 'reciboFin':gpo2ReciboFin, 'cancelados':gpo2Cancelados, 'total':gpo2Total },
                     'Volun': {'numFolios':gpo3NumFolios, 'folioIni':gpo3FolioIni, 'folioFin':gpo3FolioFin, 'reciboIni':gpo3ReciboIni, 'reciboFin':gpo3ReciboFin, 'cancelados':gpo3Cancelados, 'total':gpo3Total },
                     'SerPed':{'numFolios':gpo4NumFolios, 'folioIni':gpo4FolioIni, 'folioFin':gpo4FolioFin, 'reciboIni':gpo4ReciboIni, 'reciboFin':gpo4ReciboFin, 'cancelados':gpo4Cancelados, 'total':gpo4Total },
                     'Tienda':{'numFolios':gpo991NumFolios, 'folioIni':gpo991FolioIni, 'folioFin':gpo991FolioFin, 'reciboIni':gpo991ReciboIni, 'reciboFin':gpo991ReciboFin, 'cancelados':gpo991Cancelados, 'total':gpo991Total },
                     'Otros':{'numFolios':gpo999NumFolios, 'folioIni':gpo999FolioIni, 'folioFin':gpo999FolioFin, 'reciboIni':gpo999ReciboIni, 'reciboFin':gpo999ReciboFin, 'cancelados':gpo999Cancelados, 'total':gpo999Total },
                  });
    console.log(this.info);        
    this.totMonto = auxTot;
    this.totOperaciones = auxTotOp;          
    this.totFolios = auxTotFolios;          
    this.selMonto = selTot;
    this.selOperaciones = selTotOp;          
    this.selFolios = selTotFolios;          
    this.loading = false;
  }

  fnCambiaFecha(tipo, obj){
    this.loading = true;
    if (tipo=="INI"){
      this.fecIni = moment(obj.value.format("YYYYMMDD"));
      //--> MISMO DIA:
      this.fecFin = moment(obj.value.format("YYYYMMDD"));
    }
    if (tipo=="FIN"){
      this.fecFin = moment(obj.value.format("YYYYMMDD"));
    }
    this.fnCargaReporte();
  }

  fnClickForma(ev, id){
    //console.log("CLICK: " +  id);
    //console.log(ev);
    var auxChk =  <HTMLInputElement>document.getElementById("chkForma_" + id);
    for(var f = 0; f < this.forma.length; f++){
      if(this.forma[f].id == id){
        this.forma[f].checked = !this.forma[f].checked;
      }
    }
    ev.stopPropagation();
    setTimeout(() => {
      //console.log(this.thisForm);
      //console.log(this.forma);
      this.fnCargaReporte();
    }, 100);
  }

  onChange(idEl, item, tipo){
    //console.log("onChange: " + tipo)
    this.onClick(idEl,item,tipo);
  }

  onClick(idEl, item, tipo){
    //console.log(tipo);
    //console.log("onClick: " + idEl);
    //console.log(item);
    if(tipo=="GPO"){
      this.idGpo = idEl;
      this.thisForm.controls["gpo"].setValue(this.idGpo);
    }   
    this.fnCargaReporte();
  }

  fnClickCheck(item:any){
    console.log(item);
    if(item.sel){
      item.sel = false;
      this.selFolios -= item.n;
      this.selMonto -= item.tot;
      this.selOperaciones--;
    }
    else{
      item.sel = true;
      this.selFolios += item.n;
      this.selMonto += item.tot;
      this.selOperaciones++;
    }
  }

  fnSeleccionMultiple(sel:string){
    var auxChk;
    if(sel == "TODO"){
      for(var t = 0; t < this.tickets.length; t++){
        auxChk = <HTMLInputElement>document.getElementById("chkNota_" + this.tickets[t].minId)
        if(auxChk){
          this.tickets[t].sel = true;     
          auxChk.checked = true;   
        }
      }
      this.selFolios = this.totFolios;
      this.selMonto = this.totMonto;
      this.selOperaciones = this.totOperaciones;
    }
    if(sel == "NADA"){
      for(var t = 0; t < this.tickets.length; t++){
        auxChk = <HTMLInputElement>document.getElementById("chkNota_" + this.tickets[t].minId)
        if(auxChk){
          this.tickets[t].sel = false;        
          auxChk.checked = false;   
        }
      }
      this.selFolios = 0;
      this.selMonto = 0;
      this.selOperaciones = 0;
    }
  }

  fnExportar(){
    //console.log("Exportar a Excel");  
    this.loading=true;   
    var dataEx: any = [];
    var folioIni = 0;
    folioIni = parseInt((<HTMLInputElement>document.getElementById("txtFolioSAE")).value);
    var strCeros= '';
    if(this.lonFolioSAE > 0){
      for(var l = 0; l <= this.lonFolioSAE; l++)
        strCeros += '0';
    }
    var auxFileName = moment(this.fecIni).format("YYYYMMMDD") + moment().format("__YYMMDD_HHmm");
    for (var i = 0; i < this.tickets.length; i++){
      if(this.tickets[i].sel){
        if(this.tickets[i].n == 1){
          this.dataService.insNotaVenta(this.lonFolioSAE < 1 ? this.strPrefijoSAE + (strCeros + folioIni) : this.strPrefijoSAE + (strCeros + folioIni).slice(this.lonFolioSAE * -1), this.tickets[i].minFolio, this.tickets[i].tot, auxFileName).subscribe(
                                        rows => {   
                                                this.notaVenta = <any>rows
                                                },          
                                        error => this.errMsg = <any>error,
                                        () => this.fnTicketActualizado());
          this.dataService.updTicketNV(this.lonFolioSAE < 1 ? this.strPrefijoSAE + (strCeros + folioIni) : this.strPrefijoSAE + (strCeros + folioIni).slice(this.lonFolioSAE * -1), this.tickets[i].minFolio, this.tickets[i].tot, auxFileName).subscribe(
                                          rows => {   
                                                  this.notaVenta = <any>rows
                                                  },          
                                          error => this.errMsg = <any>error,
                                          () => this.fnNotaInsertada());
          dataEx.push({'Clave': this.lonFolioSAE < 1 ? this.strPrefijoSAE + (strCeros + folioIni++) : this.strPrefijoSAE + (strCeros + folioIni++).slice(this.lonFolioSAE * -1),
                       'Cliente': this.cteSAE,
                       'Fecha de Elaboración': moment(this.fecIni).format("DD/MM/YYYY"),
                       'Su pedido': null,
                       //'Clave del artículo': "SERV-TAQ",
                       'Clave del artículo': this.serSAE,
                       'Cantidad': 1,
                       'Precio': this.tickets[i].tot,
                       'Desc. 1': null,
                       'Desc. 2': null,
                       'Desc. 3': null,
                       'Clave de vendedor': null,
                       'Comisión': null,
                       'Clave de esquema de impuestos': null,
                       'Impuesto 1': null,
                       'Impuesto 2': null,
                       'Impuesto 3': null,
                       'Impuesto 4': null,
                       'Impuesto 5': null,
                       'Impuesto 6': null,
                       'Impuesto 7': null,
                       'Impuesto 8': null,
                       'Observaciones': "FOLIO: " + this.tickets[i].minFolio + ": " + this.tickets[i].prod + " " + (this.tickets[i].aplicaDescuento ? this.tickets[i].aplicaDescuento : "") + "  [" + this.tickets[i].forma + "]"
                      })        
          }
        else
          for(var n = 0; n < this.tickets[i].n; n++){            
            var auxFolio = folioIni++;
            var auxMinFolio = this.tickets[i].minFolio + n;
            var auxTot = this.tickets[i].tot / (this.tickets[i].n)
            this.dataService.insNotaVenta(this.lonFolioSAE < 1 ? this.strPrefijoSAE + (strCeros + auxFolio) : this.strPrefijoSAE + (strCeros + auxFolio).slice(this.lonFolioSAE * -1), auxMinFolio, auxTot, auxFileName).subscribe(
                                          rows => {   
                                                  this.notaVenta = <any>rows
                                                  },          
                                          error => this.errMsg = <any>error,
                                          () => this.fnTicketActualizado());
            this.dataService.updTicketNV(this.lonFolioSAE < 1 ? this.strPrefijoSAE + (strCeros + auxFolio) : this.strPrefijoSAE + (strCeros + auxFolio).slice(this.lonFolioSAE * -1), auxMinFolio, auxTot, auxFileName).subscribe(
                                            rows => {   
                                                    this.notaVenta = <any>rows
                                                    },          
                                            error => this.errMsg = <any>error,
                                            () => this.fnNotaInsertada());
                  
            dataEx.push({'Clave': this.lonFolioSAE < 1 ? this.strPrefijoSAE + (strCeros + auxFolio) :  this.strPrefijoSAE +  (strCeros + auxFolio).slice(this.lonFolioSAE * -1),
                        'Cliente': this.cteSAE,
                        'Fecha de Elaboración': moment(this.fecIni).format("DD/MM/YYYY"),
                        'Su pedido': null,
                        //'Clave del artículo': "SERV-TAQ",
                        'Clave del artículo': this.serSAE,
                        'Cantidad': 1,
                        'Precio': this.tickets[i].tot / (this.tickets[i].n),
                        'Desc. 1': null,
                        'Desc. 2': null,
                        'Desc. 3': null,
                        'Clave de vendedor': null,
                        'Comisión': null,
                        'Clave de esquema de impuestos': null,
                        'Impuesto 1': null,
                        'Impuesto 2': null,
                        'Impuesto 3': null,
                        'Impuesto 4': null,
                        'Impuesto 5': null,
                        'Impuesto 6': null,
                        'Impuesto 7': null,
                        'Impuesto 8': null,
                        'Observaciones': "FOLIO: " + (this.tickets[i].minFolio + n) + ": " + this.tickets[i].prod + " " + (this.tickets[i].aplicaDescuento ? this.tickets[i].aplicaDescuento : "") + "  [" + this.tickets[i].forma + "]"
                       })
            }
      }
    }
    var auxTxt = "";
    auxTxt = "Clave,Cliente,Fecha de elaboracion,Descuento Financiero,Numero de moneda,Tipo de cambio,Observaciones,Clave de vendedor,Su pedido,Precio,Desc. 1,Desc. 2,Desc. 3,Comision,Clave de esquema de impuestos,Clave del articulo,Cantidad,I.E.P.S.,Impuesto 2,Impuesto 3,I.V.A.,Clave SAT, Unidad SAT,Observaciones de partida" + "\n";
    for(var i = 0; i < dataEx.length; i++){
      auxTxt += dataEx[i].Clave + "," + dataEx[i].Cliente + "," + dataEx[i]["Fecha de Elaboración"] + ",,,,'Documento venta',,," + dataEx[i]["Precio"] + ",,,,,," + dataEx[i]["Clave del artículo"] + ",1,,,,,,," + dataEx[i].Observaciones + "\n";
    }

    this.dataService.createTxtFile(auxTxt,'NotaVenta_' + auxFileName);

    //this.excelService.exportAsExcelFile(dataEx, 'NotaVenta_' + auxFileName);
    setTimeout(() => {
      //alert("RECARGAR REPORTE")
      this.fnCargaReporte();
      this.loading=false;
      alert("Archivo de texto creado, busque en la carpeta 'Descargas");
    }, 1990);



  }

  fnTicketActualizado(){
    //console.log(this.notaVenta)
  }

  fnNotaInsertada(){
    //console.log(this.notaVenta)
  }
}

